import { getCookie } from "@base/lib/utils";
import axios from "axios";
import { SERVICE_URL } from "@app/config/getServiceUrl";

const CSRF_TOKEN_COOKIE_NAME = "csrf_token";

export const apiClient = axios.create({
  baseURL: `${SERVICE_URL}/ko`,
  withCredentials: true,
  xsrfCookieName: CSRF_TOKEN_COOKIE_NAME,
  xsrfHeaderName: "X-CSRFToken",
});

apiClient.interceptors.request.use(
  (config) => {
    const csrfToken = getCookie(CSRF_TOKEN_COOKIE_NAME);
    if (!config.headers["X-Csrftoken"] && csrfToken) {
      config.headers["X-Csrftoken"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 전역 에러 핸들링
    return Promise.reject(error);
  },
);
